import { AbstractControl } from '@angular/forms';
import { Injectable } from '@angular/core';
import { UserService, UserServiceOptions } from '@app/origami-api/services/user.service';
import { ErrorCode } from '@app/origami-api/constants';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PinAsyncValidator {
  constructor(private userService: UserService) {}

  createValidator(requestOptions: UserServiceOptions.VerifyUser) {
    return (control: AbstractControl) => {
      requestOptions.PIN = control.value;

      return this.validatePin(requestOptions).pipe(
        map((res) => {
          return res ? null : { invalidPin: true };
        }),
      );
    };
  }

  private validatePin(requestOptions: UserServiceOptions.VerifyUser): Observable<boolean> {
    return this.userService
      .verifyUser(requestOptions, [ErrorCode.PIN_IS_NOT_VALID, ErrorCode.VerifySuccess], true)
      .pipe(map((res) => res.Result));
  }
}
